import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {RouterModule, Routes} from '@angular/router';
import {EnterpBasicArchivesComponent} from "../components/enterp-basic-archives/enterp-basic-archives.component";
import {SearchParentComponent} from "../components/search-parent/search-parent.component";
import {IndexComponent} from "../components/index/index.component";
import {EnterpIntroductionComponent} from "../components/enterp-introduction/enterp-introduction.component";
import {CityListComponent} from "../components/city-list/city-list.component";
import {CityDetailComponent} from "../components/city-detail/city-detail.component";
import {CityCreditComponent} from "../components/city-credit/city-credit.component";
import {CityCreditDetailComponent} from "../components/city-credit-detail/city-credit-detail.component";
import {CityEnterApplyComponent} from "../components/city-enter-apply/city-enter-apply.component";
import {CityReportApplyComponent} from "../components/city-report-apply/city-report-apply.component";
import {CitylistcreditComponent} from "../components/citylistcredit/citylistcredit.component";
import {CreditVideoComponent} from "../components/credit-video/credit-video.component";
import {PopBoxComponent} from "../components/pop-box/pop-box.component";
import {PdfViewComponent} from "../components/pdf-view/pdf-view.component";
import {BadGuard} from "../guard/BadGuard";
import {EnterpAtlasComponent} from "../components/enterp-atlas/enterp-atlas.component";
import {EnterpEmployeesComponent} from "../components/enterp-employees/enterp-employees.component";
import {EnterpNewsInfoComponent} from "../components/enterp-news-info/enterp-news-info.component";
import { GzEcommerceSearchComponent } from '../components/gz-ecommerce-search/gz-ecommerce-search.component';
import { GzLogisticsSearchComponent } from '../components/gz-logistics-search/gz-logistics-search.component';
import {GDLoginGuard} from "../guard/GDLoginGuard";
import {BigCreditComponent} from "../components/big-credit/big-credit.component";
import {BigCreditDetailComponent} from "../components/big-credit-detail/big-credit-detail.component";
import {ProtocolMsgComponent} from "../components/protocol-msg/protocol-msg.component";
import {GDProtocolGuard} from "../guard/GDProtocolGuard";
import {InformationListComponent} from "../components/information-list/information-list.component";
import {InformationDetailComponent} from "../components/information-detail/information-detail.component";
import {GDIndexGuard} from "../guard/GDIndexGuard";

const routes: Routes = [
  /*{path: '', component: IndexComponent},*/

  /*{path: 'cityList', component: CityListComponent},
  {path: 'cityDetail', component: CityDetailComponent},

  {path: 'cityCredit', component: CityCreditComponent},
  {path: 'cityCreditDetail', component: CityCreditDetailComponent},
  {path: 'bigCredit', component: BigCreditComponent},
  {path: 'bigCreditDetail', component: BigCreditDetailComponent},
  {path: 'CityEnterApply', component: CityEnterApplyComponent},
  {path: 'CityReportApply', component: CityReportApplyComponent},
  {path: 'CitylistcreditComponent', component: CitylistcreditComponent},
  {path: 'creditVideo', component: CreditVideoComponent},
  {path: 'pdfView', component: PdfViewComponent},*/

  {path: 'popBox', component: PopBoxComponent},

  {path: 'enterpIntroduction', component: EnterpIntroductionComponent},

  // 企业基本信息
  {path: 'enterpBasicArchives', component: EnterpBasicArchivesComponent},
  // 企业图谱
  {path: 'enterpAtlas', component: EnterpAtlasComponent, canActivate:[GDLoginGuard]},
  // 董监高查询
  {path: 'enterpEmployees', component: EnterpEmployeesComponent, canActivate:[GDLoginGuard]},
  // 舆情查询
  {path: 'enterpNewsInfo', component: EnterpNewsInfoComponent},
  // 高级搜索
  {path: 'searchParent', component: SearchParentComponent, canActivate:[GDProtocolGuard]},
  // 电商
  {path: 'gzEcommerceSearch', component: GzEcommerceSearchComponent, canActivate:[GDIndexGuard]},
  // 物流
  {path: 'gzLogisticsSearchComponent', component: GzLogisticsSearchComponent, canActivate:[GDIndexGuard]},
  // 首页
  {path: '', component: GzEcommerceSearchComponent, canActivate:[GDIndexGuard]},
  // 资讯列表
  {path: 'information', component: InformationListComponent},
  // 资讯详情
  {path: 'informationDetail', component: InformationDetailComponent},


  {path: 'protocol', component: ProtocolMsgComponent},

  {path: '**', component: IndexComponent, canActivate : [BadGuard]},

];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),

  ],
  declarations: [],
  exports: [
    RouterModule
  ]
})
export class RoutingModule {
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/routing/routing.module.ts